import type * as openapi from '@/helpers/api/types/openapiOverrides';

import { AxiosPromise, AxiosRequestConfig } from 'axios';

import { api } from '@/api';

export async function getSmsDaily(
  params: openapi.SMSDailyQueryOpenapi,
  requestConfig: AxiosRequestConfig = {},
): AxiosPromise<openapi.SMSDailyContentOpenapi> {
  return await api.get<openapi.SMSDailyContentOpenapi>('/sms/daily/', {
    ...requestConfig,
    params,
  });
}

export async function postSmsDaily(
  data: openapi.SMSSendRequestOpenapi,
  requestConfig: AxiosRequestConfig = {},
): AxiosPromise<openapi.SMSSendResponseOpenapi> {
  return await api.post<openapi.SMSSendResponseOpenapi>(
    '/sms/daily/',
    data,
    requestConfig,
  );
}

export async function getSMSHistoryData(
  params: openapi.SMSHistoryQueryOpenapi,
  requestConfig: AxiosRequestConfig = {},
): AxiosPromise<openapi.SMSHistoryContentOpenapi> {
  return await api.get<openapi.SMSHistoryContentOpenapi>(
    '/sms/daily/history/',
    {
      ...requestConfig,
      params,
    },
  );
}

export async function getSmsDailyHistory(
  params: openapi.GetSmsDailyHistory_Query,
  requestConfig: AxiosRequestConfig = {},
): AxiosPromise<openapi.GetSmsDailyHistory_200> {
  return await api.get<openapi.GetSmsDailyHistory_200>('/sms/daily/history/', {
    ...requestConfig,
    params,
  });
}

export async function getSmsMessagesDaily(
  params: openapi.GetSmsMessagesDaily_Query,
  requestConfig: AxiosRequestConfig = {},
): AxiosPromise<openapi.GetSmsMessagesDaily_200> {
  return await api.get<openapi.GetSmsMessagesDaily_200>(
    '/sms/messages/daily/',
    {
      ...requestConfig,
      params,
    },
  );
}

export async function getSmsMessagesHistory(
  params: openapi.GetSmsMessagesHistory_Query,
  requestConfig: AxiosRequestConfig = {},
): AxiosPromise<openapi.GetSmsMessagesHistory_200> {
  return await api.get<openapi.GetSmsMessagesHistory_200>(
    '/sms/messages/history/',
    {
      ...requestConfig,
      params,
    },
  );
}

export async function postSmsMessagesMarkRead(
  params: openapi.PostSmsMessagesMarkRead_Query,
  data: openapi.PostSmsMessagesMarkRead_Body,
  requestConfig: AxiosRequestConfig = {},
): AxiosPromise<openapi.PostSmsMessagesMarkRead_200> {
  return await api.post<openapi.PostSmsMessagesMarkRead_200>(
    '/sms/messages/mark_read/',
    data,
    {
      ...requestConfig,
      params,
    },
  );
}

export async function postSmsMessagesSend(
  params: openapi.PostSmsMessagesSend_Query,
  data: openapi.PostSmsMessagesSend_Body,
  requestConfig: AxiosRequestConfig = {},
): AxiosPromise<openapi.PostSmsMessagesSend_200> {
  return await api.post<openapi.PostSmsMessagesSend_200>(
    '/sms/messages/send/',
    data,
    {
      ...requestConfig,
      params,
    },
  );
}

export async function getSmsMessagesConversations(
  params: openapi.GetSmsMessagesConversations_Query,
  requestConfig: AxiosRequestConfig = {},
): AxiosPromise<openapi.GetSmsMessagesConversations_200> {
  return await api.get<openapi.GetSmsMessagesConversations_200>(
    '/sms/messages/conversations/',
    {
      ...requestConfig,
      params,
    },
  );
}
